<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="account-logo"></div>
    <custom-input type="password" placeholder="请输入6-16位密码" v-model="password"></custom-input>
    <custom-input type="password" placeholder="请确认密码" v-model="passwordConfirm"></custom-input>
    <div class="forget-warn">*密码长度6-16位，支持数字、字母、下划线。</div>
    <div class="account-button" @click="submit">确认修改</div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
  </div>
</template>

<script>
  export default {
    name: "forget",
    data(){
      return {
        password:"",
        passwordConfirm:"",
        mobile:"",
        error:[],
        isDialogShow:false
      }
    },
    created(){
      // var mobile=this.$route.params.mobile;
      var mobile = this.$store.state.mobile;
      console.log(mobile)
      if(!mobile){
        this.$toast("参数错误");
        window.setTimeout(()=>{
          this.$router.push("/index");
        },1000)
      }
      else{
        this.mobile=mobile;
      }
    },
    methods:{
      submit(){
        this.$api.get("",{
          api:"/v1/passport/reset_psd",
          user_login:this.mobile,
          user_pass:this.password,
          confirm_pass:this.passwordConfirm
        },res=>{
          if(res.status===1){
            this.$toast("修改成功");
            window.setTimeout(()=>{
              this.$router.push("/login");
            },1000)
          }
          else{
            this.toast("修改失败");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .forget-warn{
    margin:0.533rem 0.4rem 0 0.4rem;
    color:#999;
    font-size:0.373rem;
    /*text-shadow:-2px -2px 0.267rem rgba(12,83,155,0.31);*/
  }
</style>



// WEBPACK FOOTER //
// src/components/forget-next/forget-next.vue